var _path, _path2, _circle, _circle2, _circle3, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRossum(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 198.4 198.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "OI_4L_main",
    d: "M116.9 146.3v21.8H15.8V29.2h101.1v23.9M116.9 78.1v24.7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "OI_4L_main",
    d: "M28.9 42.6h47.5v18.5H28.9zM146.4 77.3H180v10h-33.6zM146.4 94.8H180v10h-33.6zM146.4 111.8H180v10h-33.6zM61.2 140.2h41.2v13.5H61.2zM61.3 126.2h23.6v7H61.3zM77.1 51.6h23.2l31.4 27.2M85 129.8h15.3l31.1-27.8"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "OI_4L_main",
    cx: 135.4,
    cy: 82.2,
    r: 4.4
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "OI_4L_main",
    cx: 135.4,
    cy: 117.1,
    r: 4.4
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "OI_4L_main",
    cx: 135.4,
    cy: 99.8,
    r: 4.4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "OI_4L_main",
    d: "M103.2 147.2l29.2-26.6M30.1 86.2h65.3M30.1 95.8h65.3M30.1 105.4h65.3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRossum);
export default __webpack_public_path__ + "static/media/rossum.d96b19e4ac97325396e894c3902b1cb2.svg";
export { ForwardRef as ReactComponent };